import { motion } from "framer-motion";

import styles from '../styles';
import { fadeIn } from '../utils/motion'

const ExploreCard = ({ id, imgUrl, icone, title, num, index, active, handleClick }) => (
  <motion.div
    variants={fadeIn('right', 'spring', index * 0.5, 0.75)}
    initial='hidden'
    whileInView='show'
    className={`relative ${active === num ? 'lg:flex-[3.5] flex-[10]' : 'lg:flex-[0.5] flex-[2]'} flex items-center justify-center min-w-[170px] h-[700px] transition-[flex] duration-[0.7s] ease-out-flex cursor-pointer`}
    onClick={() => handleClick(num)}
  >
    <img 
      src={imgUrl} 
      alt={title} 
      className='absolute w-full h-full object-cover rounded-[24px]'
    />

    {
      active !== num ? (
        <h3 className="font-semibold sm:text-[26px] text-[18px] text-white absolute z-0 lg:bottom-20 lg:rotate-[-90deg] lg:origin-[0,0]">
          {title}
        </h3>
      ) : (
        <div className="absolute bottom-0 p-8 flex justify-between items-center w-full bg-[rgba(0,0,0,0.5)] rounded-b-[24px]">
          <div className={`${styles.flexCenter} w-[80px] h-[80px] rounded-[24px] glassmorphism`}>
            <img 
              src={icone} 
              alt="icone" 
              className="w-[60%] h-[60%] object-contain"
            />
          </div>
          <div className="text-end">
            <p className="font-normal text-[16px] leading-[20px] text-white uppercase">
              Genshin Impact
            </p>
            <h2 className="mt-[24px] font-semibold sm:text-[32px] text-[24px] text-white">
              {title}
            </h2>
          </div>
        </div>
      )
    }

  </motion.div>
);

export default ExploreCard;
